/**
 * @author Saad <mohammed.saadullah@314ecorp.com>
 * @description Powerpoint Outlined
 */


import classnames from 'classnames';

interface IProps {
	className?: string;
}

const PowerpointOutlined: React.FC<IProps> = (props) => {
	const { className, ...restProps } = props;
	const cn = classnames('anticon anticon-powerpointoutlined', className);
	return (
		<span role='img' aria-label='Powerpointoutlined' className={cn} {...restProps}>
			<svg
				width='14'
				height='15'
				viewBox='0 0 14 15'
				fill='none'
				aria-label='Powerpointoutlined'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M7.62703 1.11408C7.78229 1.22333 7.87467 1.4013 7.87467 1.59115V1.88282H11.083C11.4052 1.88282 11.6663 2.14398 11.6663 2.46615V3.92448H12.2497C12.894 3.92448 13.4163 4.44682 13.4163 5.09115V9.75782C13.4163 10.4021 12.894 10.9245 12.2497 10.9245H11.6663V12.3828C11.6663 12.705 11.4052 12.9662 11.083 12.9662H7.87467V13.2578C7.87467 13.4477 7.78229 13.6256 7.62703 13.7349C7.47177 13.8441 7.27305 13.871 7.09436 13.8069L2.71936 12.2373C2.4876 12.1542 2.33301 11.9345 2.33301 11.6883V10.9245H1.74967C1.10534 10.9245 0.583008 10.4021 0.583008 9.75782V5.09115C0.583008 4.44682 1.10534 3.92448 1.74967 3.92448H2.33301V3.16068C2.33301 2.91446 2.48761 2.69475 2.71936 2.61161L7.09436 1.04208C7.27306 0.977974 7.47177 1.00484 7.62703 1.11408ZM3.49967 3.92448H6.70801V2.46615V2.42016L3.49967 3.57115V3.92448ZM7.87467 3.92448H10.4997V3.04948H7.87467V3.92448ZM3.49967 10.9245V11.2778L6.70801 12.4288V12.3828V10.9245H3.49967ZM7.87467 10.9245V11.7995H10.4997V10.9245H7.87467ZM12.2497 9.75782H11.083H2.91634H1.74967V5.09115L11.083 5.09115L12.2497 5.09115V9.75782ZM3.79134 5.38282H2.91634C2.59418 5.38282 2.33301 5.64398 2.33301 5.96615V7.71615V8.88282C2.33301 9.20498 2.59418 9.46615 2.91634 9.46615C3.23851 9.46615 3.49967 9.20498 3.49967 8.88282V8.29948H3.79134C4.59677 8.29948 5.24967 7.64658 5.24967 6.84115C5.24967 6.03572 4.59677 5.38282 3.79134 5.38282ZM3.49967 7.13282V6.54948H3.79134C3.95244 6.54948 4.08301 6.68005 4.08301 6.84115C4.08301 7.00225 3.95244 7.13282 3.79134 7.13282H3.49967ZM6.12467 5.38282H6.99967C7.8051 5.38282 8.45801 6.03572 8.45801 6.84115C8.45801 7.64658 7.8051 8.29948 6.99967 8.29948H6.70801V8.88282C6.70801 9.20498 6.44684 9.46615 6.12467 9.46615C5.80251 9.46615 5.54134 9.20498 5.54134 8.88282V7.71615V5.96615C5.54134 5.64398 5.80251 5.38282 6.12467 5.38282ZM6.70801 6.54948V7.13282H6.99967C7.16077 7.13282 7.29134 7.00225 7.29134 6.84115C7.29134 6.68005 7.16077 6.54948 6.99967 6.54948H6.70801ZM10.7913 6.84115H11.083C11.4052 6.84115 11.6663 6.57998 11.6663 6.25782C11.6663 5.93565 11.4052 5.67448 11.083 5.67448H10.208H9.33301C9.01084 5.67448 8.74967 5.93565 8.74967 6.25782C8.74967 6.57998 9.01084 6.84115 9.33301 6.84115H9.62467V8.59115C9.62467 8.91332 9.88584 9.17448 10.208 9.17448C10.5302 9.17448 10.7913 8.91332 10.7913 8.59115V6.84115Z'
					fill='#FA541C'
				/>
			</svg>
		</span>
	);
};

export default PowerpointOutlined;
